import { UseArraySWROutput, useArraySWR } from '~/hooks/useSWR';
import { CollaborationReadApiClient, People } from '~/services/Http';

export const GET_EMPLOYEE_ASSIGNED_WORKLISTS_SWR_KEY =
  'CollaborationReadApiClient.getMyWorklists';

export function useGetEmployeeAssignedWorklists(args: {
  employeeId: string;
  order?: People.Order10;
  offset?: number;
  limit?: number;
  startDate?: Date;
  endDate?: Date;
  lang?: string;
  statuses?: People.TaskStatusEnum[];
  roles?: People.Roles[];
}): UseArraySWROutput<People.WorklistDto> {
  return useArraySWR(
    [
      GET_EMPLOYEE_ASSIGNED_WORKLISTS_SWR_KEY,
      args.employeeId,
      args?.order ?? undefined,
      args?.offset ?? undefined,
      args?.limit ?? undefined,
      args?.startDate ?? undefined,
      args?.endDate ?? undefined,
      args?.lang ?? undefined,
      args?.statuses ?? undefined,
      args?.roles ?? undefined,
    ],
    ([
      _,
      employeeId,
      order,
      offset,
      limit,
      startDate,
      endDate,
      lang,
      statuses,
      roles,
    ]) =>
      CollaborationReadApiClient.getMyWorklists(
        employeeId,
        order,
        offset,
        limit,
        startDate,
        endDate,
        lang,
        statuses,
        roles,
      ).then((r) => r.data),
  );
}
